import { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft, MousePointerClick } from 'lucide-react';

export const DemoGuidedTourBanner: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleExit = () => {
    // The entry points into /guided-tour set `state.from` with the origin path.
    // Falls back to the overview page when there is no origin (e.g. on refresh).
    const from = (location.state as { from?: string } | null)?.from ?? '/how-students-learn';
    navigate(from);
  };

  return (
    <div
      data-testid="demo-guided-tour-banner"
      className={`tw-top-[95px] tw-left-0 tw-right-0 tw-fixed tw-bg-stone-800 tw-px-4 lg:tw-px-28 tw-py-1 tw-flex tw-items-center tw-justify-between tw-gap-4 tw-font-atkinson tw-z-50`}
    >
      <button
        type="button"
        data-testid="demo-guided-tour-exit"
        onClick={handleExit}
        className="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-rounded-full tw-border-0 tw-bg-transparent tw-text-white tw-text-sm tw-font-bold tw-font-atkinson tw-cursor-pointer hover:tw-bg-stone-950 focus-visible:tw-outline-none focus-visible:tw-shadow-[0_0_0_2px_#ffffff,0_0_0_4px_#666056]"
      >
        <ArrowLeft size={16} aria-hidden="true" />
        Back to previous page
      </button>
      <div className="tw-flex tw-items-center tw-gap-2 tw-text-stone-100 tw-text-sm">
        <MousePointerClick size={20} className="tw-text-amber-200 tw-shrink-0" aria-hidden="true" />
        <span>Interactive demo — experiencing a skill exactly as your students do</span>
      </div>
    </div>
  );
};
